module.exports = __webpack_public_path__ + "img/purple-1-squiggly-solid.be4027e4.svg";